import {
  CancelBookingCancellerEnum,
  InvoiceStatus
} from '@link/supplier/services/const';

export default {
  layouts: {
    sidebar: {
      notifications: 'Notifications',
      contractsList: 'contract management',
      activitiesManagement: 'Product Management',
      activities: 'Product List',
      allotmentSettings: 'Inventory Settings',
      backendSettings: 'Backend Inventory Settings',
      backendCalendar: 'Calendar',
      settings: 'Settings',
      changePassword: 'Change Password',
      suppliers: 'Tour operator Management',
      suppliersDetail: 'Company Information',
      suppliersAccount: 'Account Management',
      info: 'Basic Information',
      detail: 'Detailed Information',
      agent: 'Price Group Settings',
      i18n: 'Multi-language Settings',
      planInfo: 'Plan - {{title}}',
      bookingInfoSettings: 'Booking Information Settings',
      price: 'Units/Pricing',
      addPlan: 'Add a plan',
      editMemo: 'Edit Memo',
      editLog: 'Edit History',
      adminSetting: 'Admin Settings',
      adminPlanInfo: 'Plan - {{title}} Settings',
      adminActivity: 'Product Settings',
      allotmentSetting: 'Business days and basic inventory settings',
      allotmentSegmentId: 'Add Start Time ID',
      allotmentException: 'Exception Start Time Setting',
      allotmentCalendar: 'Calendar Edit',
      allotmentOtaGroup: 'Travel agency inventory group settings',
      allotmentBackend: 'Backend Settings',
      booking: 'Booking',
      unprocessedList: 'Unprocessed List',
      finance: 'Payment Management',
      bulkOrder: 'Bulk Order',
      dataExport: 'Data Export'
    }
  },
  views: {
    dataExport: {
      period: 'Period',
      dataExport: 'Data Export',
      bookingData: 'Booking Data',
      dateMode: 'Date Mode',
      byBookingDate: 'By Booking Date',
      byParticipationDate: 'By Participation Date',
      outputMode: 'Output Format',
      byBookings: 'By Booking',
      byTravelers: 'By Traveler',
      status: 'Status',
      download: 'Download File',
      today: 'Today',
      yesterday: 'Yesterday',
      oneWeek: '1 Week',
      thisMonth: 'This Month',
      lastMonth: 'Last Month'
    },
    bulkBookingDetail: {
      history: 'Operation Details',
      action: 'Operation',
      operator: 'Operator',
      date: 'Date',
      message: 'message',
      notifyConfirmed: 'Approve Remittance',
      paymentDate: 'Remittance Date',
      paymentConfirmed: 'Remittance Approved',
      infoSentToSupplier: 'Information has been sent to the travel agency'
    },
    dashboard: {
      title: 'Dashboard'
    },
    activities: {
      templateSource: 'Product',
      heading: 'Product List',
      status: 'Status',
      title: 'Product Name',
      inputSupplierTitle: 'Please enter product name',
      addActivity: 'Product Registration',
      edit: 'Edit',
      confirmed: 'Product settings completed, ready to publish',
      name: 'Product Name',
      list: 'Product List',
      addNewActivity: 'New Product Registration',
      add: 'Register',
      selectSupplier: 'Please select a tour operator.',
      copyTitle: 'Copy Product',
      selectSupplierLabel: 'Supplier Selection',
      copy: 'Copy',
      copyModalTitle: 'Copy-{{text}}',
      export: 'Download',
      isBulkOrder: 'Bulk Order'
    },
    backendSettings: {
      newTitle: 'New Backend Inventory Setup',
      management: 'Register Inventory',
      poolId: 'Management ID',
      supplierId: 'Tour operator name',
      name: 'Management Name',
      confirm: 'Confirm',
      state: 'Status',
      status: 'Status',
      lastExecution: 'Previous Update',
      nextExecution: 'Next Update',
      jobStatus: {
        success: 'Success',
        failed: 'Failed'
      }
    },
    activity: {
      mergePlanError:
        'If a product already has existing plans, importing is not allowed',
      importError: 'File format or content is invalid',
      import: 'Import',
      title: 'Product',
      log: {
        logHistory: 'Product Edit History',
        priceHistory: 'Price Group Edit History',
        chooseLog: 'History Selection',
        chooseItemLabel: 'Plan {{index}} Edit History',
        html: 'HTML Log',
        by: 'by'
      },
      memo: {
        title: 'Edit Memo',
        tips: 'Edit memos are for internal record when editing products and will not be displayed on agency or direct sales sites',
        successUpdated: 'Memo saved'
      },
      tag: {
        title: 'Edit Tag',
        tips: 'Edit tags are for internal record when editing products and will not be displayed on agency or direct sales sites'
      },
      paymentCollector: 'Collection account',
      productDescription: 'Product Description',
      priceSetting: 'Payment Currency Settings',
      autoPublic: 'Auto Publish Settings',
      autoPublicGroup: 'Target Group Selection',
      imageSetting: 'Image Settings',
      participantNotice:
        'Notes Before/After Participation (Included Items etc.)',
      agentGroupName: 'Price Group Name',
      agentSaved: 'Travel agency saved',
      agentSetting: 'Price Group Settings',
      addAgentGroup: 'Add Price Group',
      agentTips:
        '※ Pricing groups are linked to each travel agency’s pricing settings, so one travel agency cannot be added to multiple groups.',
      comment: 'Comment',
      publishedApplied: 'Publish Requested',
      rejectApplied: 'Returned',
      approved: 'Approved',
      published: 'Published',
      publish: 'Publish',
      publishToNeoOnly: 'Publish to NEO Only',
      publishToNextOnly: 'Publish to NEXT (Current System) Only',
      reject: 'Returned',
      approve: 'Publish Approval',
      submit: 'Publish Request',
      save: 'Save',
      preview: 'Preview',
      productPreview: 'Product Preview',
      voucherPreview: 'Voucher Preview',
      applyForPublish: 'Product Publish Request',
      productConfirmationMessage:
        'Please review the registered product details and plan before publishing',
      confirmPermission: 'No Permission',
      confirmReject: 'Sent Back for Approval',
      confirmApprovalOfProduct: 'Product Publish Approval',
      productContentConfirmed: 'Product content has been confirmed',
      confirmForPublishingProducts: 'Product Publish Confirmation',
      productPublishedConfirmed: 'Product publication has been approved',
      productSaved: 'Product has been saved',
      languageSetting: 'Multi-language Settings',
      languageSelection: 'Language Selection',
      productTitle: 'Product Name (Voucher Display Name)',
      origin: 'Departure Location',
      destination: 'Destination',
      checkinPoints: 'Meeting point',
      checkoutPoints: 'Drop-off Location',
      pickupLocation: 'Pickup Location',
      dropoffLocations: 'Drop-off Location',
      cancellationPolicy: 'Cancellation Policy',
      faqSetting: 'FAQ Settings',
      chosenLanguage: 'Display Language',
      timeZone: 'Country/Region (Time Zone)',
      category: 'Category',
      useQrCode: 'QR Code Usage',
      qrcodeType: 'QR Code Type',
      qrcodeDisplayLocations: 'QR Code Display Location',
      voucherSetting: 'Voucher Settings',
      voucherVersion: 'Voucher Version',
      appointmentSetting: 'Booking Settings',
      appointmentNotification: 'Booking Notification',
      useEticketItems: 'E-Ticket Usage Items',
      qrcodeTemplate: 'QR Code Template',
      qrcodeHeader: 'QR Code Header',
      qrcodeFooter: 'QR Code Footer',
      qrcodeGenerator: 'QR Code Generator',
      redemptionUrlTemplate: 'Exchange URL Template',
      adminSettingSaved: 'Admin settings saved',
      allotmentSettingSaved: 'Plan settings saved',
      planSelection: 'Plan Selection',
      planId: 'Plan ID',
      systemCharge: 'System Fee',
      productInfo: 'Product Information',
      supplierId: 'Tour operator ID',
      supplierName: 'Tour operator name',
      name: 'Product Name',
      editMemo: 'Edit Memo',
      editTag: 'Edit Tag',
      publishActivityConfirm: 'Do you want to publish this product?',
      publishActivitySuccess:
        '※ When publishing, partner agencies added to pricing settings can view product information',
      inPublish: 'Publishing',
      isActivityPublished: 'Product has been published',
      isActivityPublishedFailed: 'Product publication failed',
      contactUs: 'Please contact the person in charge',
      leaveCurrentPage: 'Leave this page',
      continueEditing: 'Continue Editing',
      salesStatus: 'Product Display',
      hideFromSearch: 'Product List View',
      salesStatusNotes:
        '※ If display status is changed, republishing is required',
      hideFromSearchNotes:
        '※ If list display is OFF, it will not appear in search results or product lists',
      qrCodeTips:
        '※ Please contact support for QR per-person issuance or mogiri ticket scanning settings'
    },
    allotmentSettings: {
      heading: 'Business days and basic inventory settings',
      title: 'Inventory Settings',
      new: 'Register Inventory',
      poolId: 'Management ID',
      supplierId: 'Tour operator name',
      name: 'Management Inventory Name',
      inputAllotmentName: 'Please enter management inventory name',
      leaveCurrentPage: 'Leave this page',
      continueEditing: 'Continue Editing',
      edit: {
        name: 'Inventory',
        createTitle: 'New Inventory Registration',
        copyTitle: 'Copy Inventory'
      },
      form: {
        id: 'Inventory ID',
        name: 'Management Inventory Name',
        freesale: 'Free sale',
        copyCalendarEdits: 'Calendar Edit Copy',
        add: 'Add Regular Inventory'
      },
      exception: {
        name: 'Set Start Time for Specific Date',
        default: 'Regular Inventory',
        allowedDefault: 'Available',
        disallowedDefault: 'Not Available',
        defaultApplicable: '(Standard inventory applied: {{applicable}})',
        applicable: 'Apply',
        notApplicable: 'Do Not Apply'
      },
      segmentId: {
        name: 'Start Time ID',
        addPrompt: 'Add Start Time ID',
        refTime: 'Reference Time',
        startTimeIdRequired: 'Please enter Start Time ID',
        startTimeRequired: 'Please enter start time'
      },
      otaGroup: {
        name: 'Travel agency inventory group settings',
        groupName: 'Travel agency inventory group name',
        addPrompt: 'Added inventory settings for travel agencies.',
        addOta: 'Add travel agency',
        deleteOta: 'Travel agency removal'
      },
      backendBundle: {
        backendOption: 'Backend',
        bundleOption: 'Bundle',
        backendId: 'Backend Inventory ID',
        bundleChildAllotmentPoolId: 'Related Child Product Inventory ID',
        parentStartTimeId: 'Start Time Inventory ID',
        refTime: 'Reference Time',
        childStartTimeId: 'Sub-product Start Time Inventory ID',
        addPrompt: 'Add Related Child Product ID',
        label: 'Select Backend',
        bundleStartTimeSetting: 'Set Start Time ID',
        segmentTime: 'Start Time ID',
        childSegmentTimeId: 'Sub-product Start Time ID',
        backendAllotment: 'Backend Inventory Settings',
        bundleAddPrompt: 'Add Bundle Inventory Settings',
        bundleGroupHeaderText: 'Related Child Product ID'
      }
    },
    agentGroup: {
      addAgent: 'Add travel agency',
      deleteAgent: 'Travel agency removal'
    },
    plan: {
      title: 'Plan',
      saveConfirm: 'Plan saved',
      name: 'Plan Name',
      planPublish: 'Plan display visibility',
      bookingRule: 'Booking Settings',
      voucherExpiration: 'Voucher Expiration Date',
      expirationVisibilitySetting: 'Hide Voucher Expiration Date',
      visibilitySetting: {
        hideFromVoucher: 'Hide on Voucher',
        hideFromActivityDetails: 'Hide on Webpage (Product Content)',
        hideFromBookingDetails: 'Hide on Webpage (Booking Details)'
      },
      checkinPoint: 'Meeting point',
      checkoutPoint: 'Drop-off Location',
      pickupLocation: 'Pickup Location',
      dropoffLocation: 'Drop-off Location',
      unitSetting: 'Unit settings',
      priceSetting: 'Pricing Settings',
      bookingAgentRequiredInfo:
        'Representative Info - Per Reservation (Required)',
      bookingAgentRecommendedInfo:
        'Representative Info - Per Reservation (Optional)',
      bookingOtherRequiredInfo: 'Other Info - Per Booking (Required)',
      bookingOtherRecommendedInfo: 'Other Info - Per Booking (Optional)',
      participantRequiredInfo: 'User Info - Per Participant (Required)',
      participantRecommendedInfo: 'User Info - Per Participant (Optional)',
      customBookingInfo: 'Custom Booking Information',
      settingUnable: 'End date cannot be set before start date',
      description: 'Plan Description',
      imageSetting: 'Image Settings',
      availablePeriod: 'Publication Period',
      reservationRestrict: 'Booking Quantity Limit',
      pieces: 'Piece',
      min: 'Minimum',
      max: 'Maximum',
      tilde: '~',
      checklistLabel: 'Notes Before/At Participation (Included Items etc.)',
      startTime: 'Start Time',
      setSchedule: 'Schedule Settings',
      editConfirm: 'Confirm Edit',
      leave: 'Leave this page',
      continueEditing: 'Continue Editing',
      code: {
        id: 'Plan ID',
        coupon: 'Hide Bundle Child Product Voucher',
        backendId: 'Inventory Setting ID',
        backendIdLabel: 'Please select inventory settings',
        metadata: 'Metadata',
        metadataLabel: 'Please confirm the content with the development team',
        goToSetting: 'If not set, please configure it <0>here</0>',
        backend: 'Backend Info',
        backendLabel: 'Please select Backend to integrate',
        productCode: 'Product Code',
        productCodeLabel: 'Please enter product code',
        unit: 'Unit settings',
        unitType: 'Unit types',
        unitRange: 'Unit Range',
        unitCode: 'Unit Code',
        startTimeTitle: 'Start Time Setting',
        startTime: 'Start Time',
        startTimeCode: 'Start Time Code',
        codeLabel: 'Please enter code',
        linkToAllotment: 'Link to Inventory Settings'
      },
      planPublishNotes:
        '※ If plan display status is changed, republishing is required',
      duplicatePlan: 'Duplicate Plan',
      ruleDeadlineDayNotes:
        '※ If “0” is entered for booking deadline, it includes today',
      voucherExpirationNotes:
        '※ If you enter “1” in validity period, it includes today. If “0” is entered, it expires immediately'
    },
    bookingTodos: {
      title: 'Unprocessed List',
      count: 'Unit',
      within24Hours: 'Within 24 hours',
      within5Days: 'Within 5 days',
      within7Days: 'Within 7 days',
      over7Days: 'More than 7 days',
      purchasedDate: 'Payment Application Date',
      productPlan: 'Product / Plan',
      bookerName: 'Booker Name',
      deadline: 'Deadline',
      timeRemaining: 'Time Remaining Until Deadline',
      timeRemainingFormat: '{{hours}}h {{minutes}}m {{seconds}}s'
    },
    bookingDetail: {
      requestPanelTitle: 'Reply to Booking List',
      applicationDate: 'Application Date & Time',
      deadlineLabel: 'Deadline',
      accept: 'Approve',
      deny: 'Not Accepted',
      rejects: 'Reject',
      denyReasonPlaceholder: 'Please enter rejection reason',
      actionTitle: 'You have {{action}} this booking request'
    },
    bookingCancel: {
      form: 'Cancellation Form',
      canceller: 'Cancellation Reason',
      reason: 'Reason',
      comment: 'Comment',
      cancellationFee: 'Cancellation Fee',
      time: 'Current Date & Time',
      money: 'Amount',
      refundAllSystemFee: 'Full System Fee Refund',
      discount: 'X',
      percentFormula: '% =',
      pleaseSetCancelFee: 'Please set cancellation fee'
    },
    financeHistory: {
      title: 'Payment History',
      dataAggregation: 'Data Aggregation',
      aggregationUnit: 'Unit of aggregation',
      targetPeriod: 'Applicable Period',
      monthly: 'Monthly',
      weekly: 'Weekly',
      confirmed: 'Confirmed',
      canceledRefund: 'Canceled By',
      differenceAdjusted: 'Adjustment Completed',
      totalAmount: 'Total Amount',
      cancellationFee: '(Includes cancellation fee)',
      serviceFee: 'System Fee',
      totalPaymentAmount: 'Total Payment Amount',
      price: '({{currency}})',
      salesPrice: 'Selling price',
      wholesalePrice: 'Wholesale Price',
      commission: 'Commission',
      transactionSearch: 'Booking Search',
      applicationDate: 'Application Date',
      participationDate: 'Participation Date',
      transactionStatus: 'Booking Status',
      keyword: 'Keyword',
      activity: 'Product',
      plan: 'Plan',
      supplier: 'Tour operator',
      reservationNumber: 'Booking Number',
      currency: 'Currency'
    },
    financeTransactions: {
      title: 'Settlement Statement',
      transactionStatus: 'Settlement Status',
      keyword: 'ID Search',
      difference: 'Adjustment',
      dueDate: 'Invoice Issue Date',
      invoiceNumber: 'Billing ID',
      date: 'Billing Period',
      fromDate: '{{fromDate}}~{{toDate}}',
      currency: 'Currency Unit',
      amount: 'Total Payment Amount',
      adjustedAmount: 'Adjustment Amount',
      finalAmount: 'Final Total Amount',
      showjust: 'Display',
      change: 'Deposit Completed',
      invoice: 'Billing Details',
      jaInvoice: 'Japanese Invoice',
      jaInvoiceDetails: 'Statement (Japanese)',
      enInvoice: 'English Invoice',
      enInvoiceDetails: 'Statement (English)',
      attachment: 'Attachment',
      changeTitle: 'Has Deposit Been Completed?',
      changeMessage: 'Transaction status will be changed to “Deposit Completed”'
    }
  },
  common: {
    activityId: 'Template ID',
    search: 'Search',
    leaveCurrentPageConfirm: `{{name}} is still being edited. Leave this page?`,
    successCreatedMsg: '{{name}} added successfully',
    errorCreatedMsg: '{{name}} failed to add',
    successDeletedMsg: '{{name}} deleted successfully',
    errorDeletedMsg: '{{name}} failed to delete',
    successUpdatedMsg: '{{name}} updated successfully',
    errorUpdatedMsg: '{{name}} failed to update',
    sharedAllotment: 'Shared Inventory',
    colon: ':'
  },
  const: {
    cancelBookingCanceller: {
      [CancelBookingCancellerEnum.Supplier]: 'Tour operator',
      [CancelBookingCancellerEnum.SupplierForTraveler]: 'Customer'
    },
    templateStatus: {
      DRAFT: 'Draft',
      REVIEWING: 'Pending Publish Request',
      APPROVED: 'Publish Confirmed',
      PUBLISHED: 'Published (NEXT Only)',
      NEO_PUBLISHED: 'Published (NEO Only)',
      BOTH_PUBLISHED: 'Published (NEO & NEXT)'
    },
    jobState: {
      ENABLED: 'Success',
      PAUSED: 'Stop',
      DISABLED: 'Invalid',
      UPDATE_FAILED: 'Update Failed',
      ERROR: 'Error'
    },
    universalType: {
      TRUE: 'Common per plan',
      FALSE: 'Different per plan'
    },
    voucherType: {
      NONE: 'Not Required',
      COLLECTIVE: 'Booking QR Code (Per Booking)',
      INDIVIDUAL: '1 QR code per person'
    },
    qrcodeType: {
      QRCODE: 'QR Code',
      TEXT: 'TEXT',
      URL: 'URL',
      BARCODE_128: 'BARCODE_128',
      BARCODE_93: 'BARCODE_93',
      BARCODE_39: 'BARCODE_39',
      BARCODE_25: 'BARCODE_25'
    },
    qrcodeDisplayLocation: {
      QR_CODE_DISPLAY_LOCATION_VOUCHER: 'Voucher',
      QR_CODE_DISPLAY_LOCATION_ETICKET_PORTAL_SITE: 'E-Ticket Display Site'
    },
    voucherMedium: {
      ELECTRONIC: 'No Print Required (Show Screen)',
      PAPER: 'Print Required'
    },
    voucherVersion: {
      VOUCHER_VERSION_V1: 'V1',
      VOUCHER_VERSION_V2: 'V2'
    },
    formatType: {
      BEFORE_ACTIVITY_FORWARD_FIXED_CLOCK:
        'Cancellation fee of {{N}}% of total booking applies if cancelled after {{HH:MM}} local time {{D}} days before participation/usage date',
      BEFORE_ACTIVITY_FORWARD_DURATION:
        'Cancellation fee of {{N}}% of total booking applies if cancelled within {{T}} hours before participation/usage time',
      AFTER_BOOKING_FORWARD_DURATION:
        'A cancellation fee of {N} of the total reservation amount will be charged after {T} hours following the reservation confirmation.',
      AFTER_BOOKING_FORWARD_FIXED_CLOCK:
        'Starting from the booking confirmation date (day 0), a cancellation fee of {N} of the total booking amount will be charged from {D} day onwards, local time {HH:MM}.',
      BEFORE_ACTIVITY_BACKWARD_FIXED_CLOCK:
        'Cancellation fee of {{N}}% of total booking applies until {{HH:MM}} local time {{D}} days before participation/usage date',
      BEFORE_ACTIVITY_BACKWARD_DURATION:
        'Cancellation fee of {{N}}% of total booking applies up to {{T}} hours before participation/usage time',
      AFTER_BOOKING_BACKWARD_DURATION:
        'A cancellation fee of {N} of the total reservation amount will be charged for cancellations made up to {T} hours before the reservation is confirmed.',
      AFTER_BOOKING_BACKWARD_FIXED_CLOCK:
        'A cancellation fee of {N} of the total reservation amount will be charged until {HH:MM} local time on {D} day, counting the reservation confirmation date as day 0.'
    },
    cancellationFeeType: {
      PERCENTAGE: 'Percentage',
      ADVANCED_PERCENTAGE: 'Advanced percentage settings',
      FIXED: 'Fixed Rate',
      NOT_CANCELLABLE: 'Cannot Cancel'
    },
    basePrice: {
      GROSS: 'Selling price',
      NET: 'Wholesale Price',
      SUPPLIER_NET: 'Tour operator wholesale price'
    },
    confirmationType: {
      FREE_SALE: 'Participation Date Specified (Free Sale)',
      FREE_SALE_OPEN_DATE: 'No need to specify participation date (free cell)',
      INVENTORY: 'Participation Date Specified (Instant Confirmation)',
      REQUEST: 'Participation Date Required (Request)'
    },
    datePeriodUnit: {
      DAY: 'Day Calculation',
      MONTH: 'Month Calculation'
    },
    datePeriod: {
      DAY: 'Daily',
      MONTH: 'Monthly',
      tilde: '~'
    },
    collectingType: {
      PER_PARTICIPANT: 'Per Participant',
      PER_BOOKING: 'Per Booking'
    },
    collectingTiming: {
      ON_BOOKING: 'Required at Booking',
      BEFORE_ACTIVITY: 'Required by Participation Date',
      OPTIONAL: 'Optional'
    },
    formType: {
      DATE_ONLY_PAST: 'Date (Past Only)',
      DATE_ONLY_FUTURE: 'Date (Future Only)',
      TIME: 'Time',
      YES_NO: 'Yes / No',
      DROPDOWN: 'Dropdown Selection',
      RADIO: 'Radio buttons',
      CHECK: 'Checkbox',
      TEXT: 'Text',
      TEXT_ALPHANUMERIC: 'Text (Alphanumeric)',
      TEXT_PHONE: 'telephone number',
      TEXTAREA: 'Text Area'
    },
    voucherExpirationType: {
      FROM_PURCHASE_DATE: 'From the date of purchase',
      FROM_ACTIVITY_DATE: 'From participation date',
      FIXED_DATE: 'Fixed Date (Absolute)',
      RELATIVE_FIXED_DATE: 'Fixed Date (Relative)'
    },
    unit: {
      AGE_ADULT_AND_CHILD: 'Adult / Child (Common) ({n}-{m})',
      AGE_ADULT: 'Adult ({n}-{m})',
      AGE_YOUTH: 'Youth ({n}-{m})',
      AGE_CHILD: 'Child ({n}-{m})',
      AGE_SENIOR: 'Senior ({n}-{m})',
      AGE_INFANT: 'Infant ({n}-{m}) years old',
      AGE_STUDENT: 'Student ({n}-{m})',
      AGE_HIGH_SCHOOL: 'High school student ({n}-{m}) years old',
      AGE_INTERMEDIATE_SCHOOL: 'Junior High School Student ({n}-{m})',
      AGE_ELEMENTALY_SCHOOL: 'Elementary School Student ({n}-{m})',
      AGE_COLLEGE: 'University Student ({n}-{m})',
      AGE_GRADUATE: 'Graduate Student ({n}-{m})',
      AGE_DISABLED_ADULT: 'Person with disability - Adults ({n}-{m}) years old',
      AGE_DISABLED_YOUTH: 'Person with disability - Youth ({n}-{m})',
      AGE_DISABLED_CHILD: 'Person with disability - Child ({n}-{m}) years old',
      AGE_SUPPORTER_ADULT: 'Caregiver (Adult)',
      AGE_SUPPORTER_CHILD: 'Caregiver (Child)',
      MINUTES_VEHICLES: '{n} minutes',
      HOURS_VEHICLES: '{n} hours',
      DAYS_VEHICLES: '{n} days',
      WEEKS_VEHICLES: '{n} weeks',
      NIGHTS_VEHICLES: '{n} nights',
      CHARTER_VAR: '1 vehicle ({n}-{m}) people',
      GROUP_VAR: '1 group ({n}-{m}) people',
      ROOM_VAR: '1 room ({n}-{m}) people',
      BOAT_VAR: '1 vehicle ({n}-{m}) people',
      PET: 'pet',
      PET_CAT: 'Cat',
      PET_DOG: 'Dog',
      PET_DOG_S: 'Small Dog',
      PET_DOG_M: 'Medium Dog',
      PET_DOG_L: 'Large Dog',
      PET_DOG_XL: 'extra large dog',
      PET_OTHER: 'Other Pets',
      AGE_ADULT_AND_CHILD_2: 'General',
      AGE_CHILD_2: 'Child',
      DRINK_STANDARD_SET: 'THE ROOF SEAT & STANDARD SET',
      DRINK_CHAMPAGNE_SET: 'THE ROOF SEAT & CHAMPAGNE SET',
      QUANTITY: '1 Quantity'
    },
    invoiceStatus: {
      [InvoiceStatus.InvoiceStatusPending]: 'Payment Pending',
      [InvoiceStatus.InvoiceStatusConfirmed]: 'Payment Completed',
      [InvoiceStatus.InvoiceStatusPaid]: 'Payment Confirmation in Progress',
      [InvoiceStatus.InvoiceStatusCancelled]: 'Cancelled'
    },
    activityTags: {
      NON_CANCELLABLE: 'Cannot Cancel',
      FREE_CANCEL_BEFORE_ISSUE_TICKET: 'Free cancellation before exchange',
      ADVANCE_CANCELLATION_POLICY: 'Special Cancellation Policy',
      INSTANT_BOOK: 'Instant Booking',
      NON_QR_CODE: 'Physical Voucher',
      QR_CODE: 'QR Voucher',
      ETICKET: 'Ticket tear-off (smartphone required)'
    }
  },
  lang: {
    en: 'English',
    ja: 'Japanese',
    zh: 'Chinese (Simplified)',
    zt: 'Chinese (Traditional)',
    ko: 'Korean'
  },
  component: {
    location: {
      title: '{{label}} Name',
      address: 'Address',
      placeId: 'Location ID',
      latlong: 'Latitude / Longitude',
      select: 'Select {{label}}',
      errMsg:
        'No search results found. Please check your input or select directly from the map'
    },
    checklist: {
      notice: 'Note {{index}}',
      selectNoticePrompt: 'Please select pre-/during-participation notes',
      uploadPDF: 'PDF Upload',
      uploadImage: 'Upload Image',
      googleMapSetting: 'Google Map Settings'
    },
    cancel: {
      notCancellable: 'Cancellation and changes are not accepted after booking',
      freeCancellable:
        'Free cancellation before exchange. No refund after exchange',
      flex: 'Set an advanced cancellation policy.',
      preview: 'Preview',
      cancelPreview: 'Cancellation Policy Preview',
      info: 'Custom Description',
      timeSetting: 'Cancellation Date/Time Setting',
      day: 'Day {D}',
      timeFormat: 'Time {HH:MM}',
      time: 'Time {T}',
      feeSetting: 'Cancellation Fee Settings',
      feeSettingPrompt: 'Please select cancellation fee settings',
      cancelPolicyPrompt: 'Please select cancellation policy',
      priceReferenceSale: 'Price Basis: Sales Price',
      priceReference: 'Price Basis:',
      fromClient: 'From Traveler  (%)',
      fromAgent: 'From the travel agency (%)',
      toSupplier: '(%) to the tour operator',
      paymentCancelFee: 'Cancellation Fee Payment',
      fromClientToAgent: 'Traveler → Travel Agency',
      fromAgentToLinktivity: 'From travel agency to LINKTIVITY',
      fromLinktivityToSupplier: 'LINKTIVITY to Supplier'
    },
    rule: {
      type: 'Booking Type',
      possibleInterval: 'Booking Available Period',
      interval: 'Booking Deadline Date',
      daysBefore: 'Days Ago',
      timeBefore: 'Until {time}'
    },
    faq: {
      question: 'question',
      answer: 'answer',
      faqTitle: 'Item {{index}}'
    },
    voucher: {
      incrementDate: 'Annual Increment Reference Date'
    },
    startTime: {
      id: 'ID',
      name: 'Start Time',
      title: 'Title',
      poolId: 'Start Time ID'
    },
    itinerary: {
      title: 'Title',
      detailedSchedule: 'Schedule Details'
    },
    additional: {
      id: 'Booking Information ID',
      title: 'Booking Information Title',
      info: 'Booking Information Description',
      setting: 'Booking Information Setup Method',
      deadline: 'Deadline for responses',
      answerType: 'Answer format',
      selectItems: 'Selection Item',
      selectPrompt: 'Please select'
    },
    price: {
      info: 'Price {{index}}',
      reservableInterval: 'Booking Available Period',
      startTime: 'Start Time',
      endTime: 'End Time',
      unitType: 'Unit types',
      unitPrice: 'Selling price',
      soldPrice: 'Selling price',
      agentPrice: 'Wholesale Price',
      comission: 'Commission',
      price: 'Price',
      accuracy: 'Accuracy',
      rate: 'rate',
      comissionRate: 'Commission Rate (Display)',
      comissionRateTips:
        'The exchange rate shown here will be used in reports and documents',
      auto: 'Rate accuracy settings',
      applicableSetting: 'Applicable Period Settings',
      applicableInterval: 'Applicable Period',
      applicableDates: 'Applicable Days',
      otherApplicableDates: 'Other Applicable Date',
      unitRange: 'Unit Range',
      standardPrice: 'Standard Price',
      numberIncluded: 'Included in Capacity',
      soloPurchase: 'Single Purchase'
    },
    backendForm: {
      cloudSchedulerJob: 'Sync ID',
      state: 'Status',
      status: 'Status',
      lastExecution: 'Previous Update',
      nextExecution: 'Next Update',
      selectSupplier: 'Supplier Selection',
      name: 'Management Name',
      backendPoolId: 'Backend Inventory Management ID',
      backend: 'Backend Info',
      selectBackendPlaceholder: 'Please select Backend to integrate',
      supplierPoolId: 'Supplier Pool ID',
      scheduleTimezone: 'Update Timezone',
      schedule: 'Update Schedule',
      scheduleNote: '※ Please refer to the instructions here.'
    },
    dateSetting: {
      titlePlaceholder: 'Please enter inventory management name',
      name: 'Set Regular Inventory',
      interval: 'Applicable Period (Days of Week)',
      exactDates: 'Specific Date',
      commonAllotment: 'Inventory Settings',
      add: 'Add Regular Inventory Pattern',
      common: 'Common',
      freesale: 'Free sale',
      createTitle: 'Inventory Pattern Settings',
      modal: {
        interval: 'Applicable Period',
        dates: 'Applicable Days',
        otaAllotments: 'Travel agency inventory settings'
      }
    },
    editAllotment: {
      type: 'Type',
      amountReserved: 'Booking Quantity',
      amountEdited: 'Inventory Quantity',
      amountRemains: 'Remaining Inventory',
      shared: 'Shared Inventory'
    },
    calendar: {
      groupRule: 'Inventory Display',
      week: 'Week',
      month: 'Month',
      showMore: 'More Info',
      amountReserved: 'Actual Number of Reservations',
      amountLimit: 'Maximum Reservations',
      edited: 'Set in Calendar Edit',
      notice: {
        title:
          'Please be careful when changing inventory directly on this page.',
        orderLabel: 'Recommended setup order:',
        orderValue:
          '[Business days and basic inventory settings] → [Exception Start Time Setting]',
        tempLabel: 'Temporary adjustment / emergency close:',
        tempValue: 'Change it directly in [Calendar Edit].',
        priorityLabel: 'Priority rules:',
        priorityValue:
          '[Calendar Edit] (highest) → [Exception Start Time Setting] (medium) → [Business days and basic inventory settings] (base)',
        remark:
          'Note: Once inventory is set in [Calendar Edit], the regular and exception settings for that time slot become invalid automatically, and only the value in [Calendar Edit] applies.'
      }
    },
    segmentId: {
      name: 'Start Time ID',
      addPrompt: 'Add Start Time ID',
      refTime: 'Reference Time',
      startTimeIdRequired: 'Please enter Start Time ID',
      startTimeRequired: 'Please enter start time'
    }
  }
};
